module.exports = __webpack_public_path__ + "img/ic_contentitem_success.2a211f2a.svg";